// -----------Importar Componentes de Terceros---------------------
import Typography from '@mui/material/Typography';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const CarritoMovil = ({ ListCarritoIncluido, StyleDragArea, FormatearComoMonedaMXN, SetNombreSeleccionado, FormActualizar, Step_PersonalizaSet, Step_Extra, ListTypo, Step_Pago, SubTotal, SubTotalExtra, StepLenght, HandleNext, Desplegar, setDesplegar }) => {
    return (
        <div>
            <div className="col-sm-12" style={{ border: 'solid 2px #d63384 ', borderRadius: '10px' }}>

                <div style={{ padding: '5px 10px' }} id="divVelacion">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: FormActualizar.TipoDespedida === '' ? 'center' : 'flex-start' }}>
                        <h5 style={{ color: '#d63384 ', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '16px', marginBottom: '0px' }}>
                            Sets seleccionado: &nbsp; &nbsp;
                        </h5>
                        <IconButton sx={{ padding: '0px !important', background: '#d63384 ' , border:'solid 2px #d63384','&:hover':{transform:'none !important'}}} onClick={() => (setDesplegar(!Desplegar))} size="small"><KeyboardArrowDownIcon sx={{ fontSize: '25px', color: 'white', rotate: Desplegar ? '180deg' : '0deg','&:hover':{color:'#d63384'} }} /></IconButton>

                    </div>


                    <Typography variant='h6' id='NuevoSeleccionado' sx={{ fontSize: '24px !important' }}>
                        {SetNombreSeleccionado}  {FormActualizar.TipoDespedida === '' ? '' : 'con ' + ListTypo.find((element) => (element.id === FormActualizar.TipoDespedida)).Nombre}
                    </Typography>


                </div>
                {
                    Desplegar === true
                        ?
                        <>
                            <div id="divCarrito" className="mt-4 text-start">
                                {
                                    Step_PersonalizaSet.ListCarrito.length > 0
                                        ?
                                        <>
                                            <h6 style={{fontSize:'24px'}}>Productos incluidos</h6>
                                            <ul className='ListSeviciosIncluidos'>
                                                {
                                                    Step_PersonalizaSet.ListCarrito.map((element, index) => {
                                                        let cantidadASumar = 0;
                                                        const productoEncontrado = Step_PersonalizaSet.ListProductos.find((producto) => (producto.producto === element.producto && producto.grupo === element.grupo));
                                                        if (productoEncontrado && productoEncontrado.valor_default === 1) {
                                                        } else {
                                                            const productosEnMismoGrupo = Step_PersonalizaSet.ListProductos.filter((producto) => (producto.grupo === element.grupo && producto.valor_default === 1));
                                                            cantidadASumar = element.precio_venta - productosEnMismoGrupo[0].precio_venta;
                                                        }
                                                        return (
                                                            <li key={index}>
                                                                <div className="row">
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="col-sm-12">
                                                                        <Typography className={cantidadASumar !== 0 ? "c_rosa" : "c_negro"} sx={{fontSize:'16px'}}>-
                                                                            {element.nombre_prodcto}
                                                                        </Typography>
                                                                        {
                                                                            cantidadASumar !== 0
                                                                                ?
                                                                                <button disabled={Step_Pago.FormPago.PedidoCliente !== '' ? true : false} type="button" onClick={() => (Step_PersonalizaSet.EliminarCarrito(element))} style={{ display: 'flex', alignItems: 'center', padding: 0, borderColor: 'white', verticalAlign: 'bottom' }} className="btn btn-rosa elimina">
                                                                                    <Typography fontSize='16px'>{cantidadASumar !== 0 ? `+${FormatearComoMonedaMXN(cantidadASumar)}` : ""}</Typography> <DeleteOutlineOutlinedIcon />
                                                                                </button>
                                                                                : <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                            <h6 style={{fontSize:'24px'}}>Servicios incluidos</h6>
                                            <ul className='ListSeviciosIncluidos'>

                                                {
                                                    ListCarritoIncluido.map((item, index) => (
                                                        <li key={index} style={{fontSize:'16px'}}>&middot; {item.nombre_prodcto}</li>
                                                    ))
                                                }
                                               
                                            </ul>
                                            <div className="mt-3" style={{ display: 'flex', justifyContent: 'space-between'}} >
                                                <h6 style={{fontSize:'22px'}}>
                                                    Subtotal productos:
                                                </h6>
                                                <h6 style={{fontSize:'22px'}}>{FormatearComoMonedaMXN(SubTotal)}</h6>
                                            </div>
                                        </>
                                        : <></>
                                }
                            </div>
                            {
                                Step_Extra.ListCarritoExtras.length > 0
                                    ?
                                    <div id="divCarrito_extras" className="mt-4 text-start">
                                        <>
                                            <Typography variant='h6' style={{fontSize:'24px' }} >Productos Extra</Typography>
                                            <ul className='ListSeviciosIncluidos'>
                                                {
                                                    Step_Extra.ListCarritoExtras.map((element, index) => {
                                                        return (
                                                            <li>
                                                                <div className="row">
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="col-sm-12">
                                                                        <Typography className="c_rosa" sx={{fontSize:'16px'}} >
                                                                            {`[${element.cantidad}] ${element.nombre_prodcto}`}
                                                                        </Typography>
                                                                        <button disabled={Step_Pago.FormPago.PedidoCliente !== '' ? true : false} type="button" onClick={() => (Step_Extra.EliminarCarritoExtra(element))} className="btn btn-rosa elimina" style={{ display: 'flex', alignItems: 'center', padding: 0, borderColor: 'white', verticalAlign: 'bottom' }}>
                                                                            <Typography fontSize='16px'>{`+${FormatearComoMonedaMXN(element.precio_venta * element.cantidad)}`}</Typography> <DeleteOutlineOutlinedIcon />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                            <div className="mt-3" style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                <h6 style={{fontSize:'22px'}}>Subtotal:</h6><h6 style={{fontSize:'22px'}}>{FormatearComoMonedaMXN(SubTotalExtra)}</h6>
                                            </div>

                                        </>
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                Step_Pago.FormPago.Descuento > 0
                                    ?
                                    <div id="divCarrito_extras" className="mt-4 text-start">
                                        <>
                                            <h6>Descuentos</h6>
                                            <ul className='ListSeviciosIncluidos'>
                                                <li>&middot; {Step_Pago.FormPago.FolioCupon}</li>
                                            </ul>
                                            <div className="mt-3" style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                <h6>Subtotal: </h6><h6>-{FormatearComoMonedaMXN(Step_Pago.FormPago.Descuento)}</h6>
                                            </div>
                                        </>
                                    </div>
                                    :
                                    <></>
                            }
                        </>
                        : <></>
                }



                <div  style={{ display: 'flex', justifyContent: ' space-between' }} >
                    <Typography className='mb-0' color='#d14081' paddingLeft='10px' fontSize='24px !important'>Total:</Typography>
                    <Typography className='mb-0' color='#d14081' paddingRight='10px' fontSize='24px !important'> {FormatearComoMonedaMXN(SubTotal + SubTotalExtra - Step_Pago.FormPago.Descuento)}</Typography>
                </div>


            </div>
            {
                StepLenght > 1
                    ?
                    <></>
                    :
                    Step_PersonalizaSet.ListGrupos.filter((element) => (element.select === false)).length > 0 || Step_PersonalizaSet.ListGrupos.length === 0
                        ?
                        <></>
                        :
                        <StyleDragArea>
                            <button disabled={Step_PersonalizaSet.ListCarrito.length > 0 ? false : true} style={{ width: '100%', display: 'block' }} id="btnSiguiente" onClick={() => { Step_Extra.ListProductosExtras.length === 0 ? Step_Extra.CargarProductosExtras() : HandleNext('StepLenght') }} className="btn btnAmarilloChico g mt-1" ><Typography fontSize='24px !important'>Siguiente</Typography></button>
                        </StyleDragArea>
            }

        </div>

    );
}

export default CarritoMovil;


